import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ContactForm from './ContactForm';

function ContactUs() {

  return (
    <Box
      sx={{
        py: { xs: 6, md: 12 },
        background: 'linear-gradient(135deg, rgba(7, 40, 75, 0.03) 0%, rgba(159, 33, 34, 0.02) 50%, rgba(7, 40, 75, 0.05) 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 20%, rgba(159, 33, 34, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(7, 40, 75, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 40% 60%, rgba(159, 33, 34, 0.03) 0%, transparent 50%)
          `,
          zIndex: 1
        }
      }}
    >
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2, px: { xs: 2, md: 4 } }}>
        <Box
          sx={{
            py: { xs: 4, md: 6 },
            px: { xs: 2, md: 6 },
            bgcolor: 'rgba(255, 255, 255, 0.95)',
            borderRadius: 4,
            position: 'relative',
            overflow: 'hidden',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(135deg, rgba(7, 40, 75, 0.02) 0%, rgba(159, 33, 34, 0.02) 100%)',
              zIndex: 1
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              top: -50,
              right: -50,
              width: 100,
              height: 100,
              background: 'linear-gradient(45deg, rgba(159, 33, 34, 0.1), transparent)',
              borderRadius: '50%',
              zIndex: 1
            }
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Typography
              variant="h4"
              sx={{
                color: '#07284b',
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: '1.8rem', md: '2.2rem' },
                lineHeight: 1.3,
                textAlign: 'center'
              }}
            >
              Contact Us
            </Typography>
            
            <Typography
              variant="body1"
              sx={{
                color: '#5a6c7d',
                mb: 4,
                fontSize: '1rem',
                lineHeight: 1.6,
                textAlign: 'center',
                maxWidth: '600px',
                mx: 'auto'
              }}
            >
              Fill out the form below and we'll get back to you within 24 hours. 
              We're here to help you start your Mandarin learning journey!
            </Typography>

            <ContactForm />
          </Box>
        </Box>

      </Container>
    </Box>
  );
}

export default ContactUs;
